import React,{useState,useEffect} from 'react'
import  './ProductCardElastic.module.css'
import { Button,Modal,Form,Card  } from 'react-bootstrap';
import InventoryPrice from '../InventoryPrice/InventoryPrice';
import RequestManager from "../../singletons/RequestManager";
import Switch from "react-switch";
import LoadingOverlay from "react-loading-overlay";

import BootstrapSwitchButton from 'bootstrap-switch-button-react'
// import Stockswitch from './Stockswitch';



function index(props) {
  
  const [show, setShow] = useState(false);
  const [checkstock,setCheckstock]=useState(false)
  const [NewCreatedStock_ID,setNewCreatedStock_ID]=useState()
  const [Instockval,setCheckstockorinstock]=useState(null)
  const [stock,setChecked]=useState(false)
  const [forstockdetails,setForstockdetails]=useState(null)
  const [spinnerLoading, setSpinnerLoading] = useState(false);

  const getGraphQLId = (modal, data) => {
    const encodedString = Buffer.from(modal+':'+ data).toString('base64');
    // console.log('getGraphQLId', encodedString);
    return encodedString;
    }

    const Inventoryproductdetails = {
      category_id: props.type === "templatestore" ?   props.pro._source.category_id : props.product.category.id,
      category_name: props.type === "templatestore" ?   props.pro._source.category_name : props.product.category.name,
      in_stock: props.type === "templatestore" ?   props.pro._source.in_stock : props.product.skus.edges[0].node.stocks.edges[0].node.inStock,
      mrp: props.type === "templatestore" ?   props.pro._source.mrp : props.product.skus.edges[0].node.maximumRetailPrice,
      product_description: props.type === "templatestore" ?  props.pro._source.product_description : "",
      product_id: props.type === "templatestore" ?   props.pro._source.product_id :  props.product.id,
      product_image: props.type === "templatestore" ? "https://res.cloudinary.com/grabbngo/image/upload/"+props.pro._source.product_image : props.product.image, 
      product_name: props.type === "templatestore" ?   props.pro._source.product_name : props.product.name, 
      sale_price: props.type === "templatestore" ?   props.pro._source.sale_price : props.product.skus.edges[0].node.stocks.edges[0].node.salePrice,
      sku_id: props.type === "templatestore" ?  getGraphQLId('sku',props.pro._source.sku_id)  : props.product.skus.edges[0].node.id,
      sku_image: props.type === "templatestore" ?   props.pro._source.sku_image : props.product.skus.edges[0].node.image,
      sku_name: props.type === "templatestore" ?  props.pro._source.sku_name : props.product.skus.edges[0].node.name,
      stock_id:checkstock == true ? NewCreatedStock_ID : props.type === "templatestore" ? getGraphQLId('Stock', props.pro._source.stock_id)  : props.product.skus.edges[0].node.stocks.edges[0].node.id,
      store_id:  props.storeid ,
      quantity: props.type === "templatestore" ?  props.pro._source.variation : props.product.skus.edges[0].node.quantity,
     
    };
    // console.log(Inventoryproductdetails,"input")

    useEffect(() => {
    
      forstockqury(Inventoryproductdetails.stock_id)
      
      getStockDetails(Inventoryproductdetails.sku_id, props.storeid,Inventoryproductdetails.sale_price,Inventoryproductdetails.mrp)

    }, [Inventoryproductdetails.sku_id,props.storeid,Inventoryproductdetails.sale_price,Inventoryproductdetails.mrp]);


 // check n create stock
    if(show == true){

      if(checkstock == true){
      
        // console.log("check from",Inventoryproductdetails.sku_id, props.storeid,Inventoryproductdetails.sale_price,Inventoryproductdetails.mrp)
      createStock(Inventoryproductdetails.sku_id, props.storeid,Inventoryproductdetails.sale_price,Inventoryproductdetails.mrp,Inventoryproductdetails.sku_name);
      }else{
        console.log("stock is available ")
      }

    }

    useEffect(() => {
      return function(){
        forstockqury()
        //console.log("call")
        setForstockdetails
    };
  
    
      
    
    },[]);

  async function forstockqury(){

    let requestManager = new RequestManager();

      const stockdata = await requestManager.getResponseFromPredefinedQuery(
        "stocks",
        
        {
  
          "forStocks": Inventoryproductdetails.stock_id
        }
      );
      //console.log(stockdata && stockdata.data.stocks.edges[0].node,"forstock")

      setForstockdetails(stockdata && stockdata.data.stocks.edges[0].node)


  }
    const getStockDetails = async (sku_id, store_id,sale_price,mrp) => {
      // console.log(sku_id,"sku_id")
      let requestManager = new RequestManager();

      const data = await requestManager.getResponseFromPredefinedQuery(
        "GET_STOCK_FOR_SKU",
        {
          skuId: [sku_id],
          storeId: store_id,
        }
      );


      // console.log(data,"getstockdetails")

      // check stock is created or not
      if (data && data.data.stocks.edges.length == 0  ) {
        setCheckstock(true)
      
     
       }
      else if (data && data.data.stocks.edges.length > 0) {
        setCheckstockorinstock(data.data.stocks.edges[0].node.inStock)
        setChecked(data.data.stocks.edges[0])
         //console.log(data.data.stocks.edges[0].node.inStock)
        //  console.log(data.data.stocks.edges[0],"asa")
      
      } else if (data.errors) {
        console.log(data.errors)
    
      }
    };

    async  function createStock(sku_id,store_id,sale_price,mrp,sku_name,inStock){
      // alert("I am inside createStock")
      let requestManager = new RequestManager();
      const store_ccy = 'INR';
     
      const input = {
        priceCurrency: store_ccy,
        price:mrp,
        settlementPriceCurrency:store_ccy,
        settlementPrice:sale_price,
        inStock:inStock,
        salePriceCurrency:store_ccy,
        salePrice:sale_price,
        stockSla:900,
        sku:sku_id, 
        store:store_id,
        isMrpItem:true,
        referenceName:sku_name
      };

      //console.log("createinput",input)

      const data = await requestManager.getResponseFromPredefinedQuery(
        "CREATE_STOCK",
        { input: input }
      );
      //console.log(data,"createreturn")
     //console.log(data.data.updateStock.stock.id,"update")
     setNewCreatedStock_ID(data.data.updateStock.stock.id)
      // return data;

    };

  const  toggleInStock = async (stock, inStock) => {
      // this.setState({ inStock });
      //console.log(inStock,"inStock")
      //console.log(stock,"a")
      if(stock == false){
        createStock(Inventoryproductdetails.sku_id, props.storeid,Inventoryproductdetails.sale_price,Inventoryproductdetails.mrp,Inventoryproductdetails.sku_name,false);
       setSpinnerLoading(false);
        window.location.reload(false);
     
        
      }else{
      let requestManager = new RequestManager();
      let params = {
        input: {},
      };
      if (inStock === true) {
        //console.log(stock ? stock.node.id : "","dccccccchg")
        params.input.inStockIds = [stock &&  stock.node.id];
        params.input.outStockIds = [];
      } else if (inStock === false) {
        params.input.outStockIds = [stock && stock.node.id];
        params.input.inStockIds = [];
      }
  //console.log(params,"params")
      let response = await requestManager.getResponseFromPredefinedQuery(
        "updateStock",
        params
      );
      if (response.error === null) {
        // let stocks = JSON.parse(JSON.stringify(this.state.stocks));
        //console.log(response,"stocks")
        // let updatedStock = stocks.find((stateStock) => {
        //   return stateStock.node.id === stock.node.id;
        // });
  
        // alert(JSON.stringify(updatedStock))
        // updatedStock.node.inStock = inStock;
        // this.setState({
        //   stocks: stocks,
        //   // filterData: filterData(stocks),
        //   // spinnerLoading: false,
        // });
      } else {
        setSpinnerLoading(false);
        
        window.location.reload(false)
      }
      // alert(
      //   "Stock Is  Created."
      // );
      // window.location.reload(false);
    
    }
    }
  
  
  // console.log(Instockval,"Instockval")

  return (

    <LoadingOverlay
    style={{ width: "100%", height: "100%", zIndex: 999 }}
    active={spinnerLoading === true ? true : false}
    spinner
    text="Loading ..."
  >
    <div className="col-md-3 ">
    <div className="card border carddesign" style={{width: '10rem',borderRadius:'8px'}}>
<div className="img_div">
<img  
    className="card-img-top prod_img"
src={Inventoryproductdetails.product_image} alt="img not found" />
</div>
        <div  className="card-body container  prod_content ">
            <p className="card-text prod_content" style={{ fontSize:"10px"}}>{Inventoryproductdetails.product_name}</p>
        </div>
        <div className="bottom_bar_2">
          <p className="bottom_left_2" style={{fontSize:8}}> In-Stock </p>
          <p className="bottom_right_2" style={{fontSize:8}}> Sale Price </p>
        </div>
        <div className=" bottom_bar" style={{background:"#fdb368",borderRadius:'0 0  0 8px',height:"40px"}}>
            <div className="row p-0 m-0" >
                
           
                
                  <Switch className="bottom_left"  onChange={(checked, event, id) => {
                              toggleInStock(stock, checked);
                            }} 
                            checked={stock && stock.node.inStock == false ? false : true  }
                            id={(stock && stock.node.id).toString() } 
                            />
                
                
                <div  style={{background:"#fdb368",borderRadius:'0 0  8px 0',cursor:"pointer"}} onClick={() => setShow(true)}>
                    <div  className=" mt-2 ml-2" className="bottom_right"  >
                      <span>&#x20B9; {checkstock == true ? Inventoryproductdetails.mrp : forstockdetails && forstockdetails.salePrice} </span>
                          <i className="fa fa-edit sm" style={{fontSize:'14px'}}></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

                

          
          <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header  closeButton>
       
        <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: 20, fontWeight: "bold" }}>
         Product
        </Modal.Title>
        <img  
          className="card-img-top prod_img"
            src={Inventoryproductdetails.product_image} alt="img not found" />
            
        </Modal.Header>
        <Modal.Body>
        
        <InventoryPrice stock={Inventoryproductdetails} forstockdetails={forstockdetails} checkstock={checkstock}/>
        </Modal.Body>
       
      </Modal>
       
       
      </div> 
      </LoadingOverlay>
  )
}

export default index



// WEBPACK FOOTER //
// ./src/components/ProductCardElastic/index.js